import styled from 'styled-components';

import Card from 'components/insights/layout/Card';
import AnalyticsResponseData from 'components/insights/query/AnalyticsResponseData';
import { ScrollContainer } from 'components/shared/DataTable';
import { useInboundReferralsInsightsStore } from 'stores/inboundReferralsInsightsStore';

import { INBOUND_VIEW_BY_ENTITY_HEADER } from '../constants';

import InboundReferralDetailsHeader from './InboundReferralDetailsHeader';
import InboundReferralDetailsTable from './InboundReferralDetailsTable';

type Props = {
  loading: boolean;
  data: AnalyticsResponseData;
};

export default function InboundReferralDetailsSection({ loading, data }: Props) {
  const viewBy = useInboundReferralsInsightsStore((state) => state.viewBy);
  const entityHeader = INBOUND_VIEW_BY_ENTITY_HEADER[viewBy];

  return (
    <SectionCard>
      <InboundReferralDetailsHeader />
      <TableWrapper>
        <InboundReferralDetailsTable loading={loading} data={data} entityHeader={entityHeader} />
      </TableWrapper>
    </SectionCard>
  );
}

const SectionCard = styled(Card)`
  padding: 0;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
`;

const TableWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 24px 24px;

  td:first-child:not(:last-child),
  th:first-child {
    border-right: 1px solid ${({ theme }) => theme.colors.black10};
  }

  @media (max-width: 800px) {
    padding: 0;

    ${ScrollContainer} {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-left: none;
      border-right: none;
      border-bottom: none;
    }
  }
`;
